import { cva, type VariantProps } from "class-variance-authority"

const buttonVariants = cva(
  "inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap text-base font-medium transition-[color,box-shadow] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:bg-primary",
        success:
          "bg-emerald-500 text-white hover:bg-emerald-600 focus-visible:ring-emerald-500/20 dark:bg-emerald-600 dark:hover:bg-emerald-700 dark:focus-visible:ring-emerald-600/40",
        destructive:
          "bg-red-500 text-white hover:bg-red-600 focus-visible:ring-red-500/20 dark:bg-red-600 dark:hover:bg-red-700 dark:focus-visible:ring-red-600/40",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        brand: "bg-utrecht-red hover:bg-utrecht-red/90 text-white",
        header: "bg-[#333] text-white hover:bg-primary rounded-none",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>.sr-only]:size-9 has-[>.sr-only]:p-0",
        sm: "h-8 gap-1.5 px-3 has-[>.sr-only]:size-8 has-[>.sr-only]:p-0",
        lg: "h-10 px-5 has-[>.sr-only]:size-10 has-[>.sr-only]:p-0",
        xl: "h-14 px-6 has-[>.sr-only]:size-14 has-[>.sr-only]:p-0",
        xxl: "h-16 px-6 text-lg has-[>.sr-only]:size-16 has-[>.sr-only]:p-0",
        icon: "size-9",
        "icon-xl": "size-14",
        "icon-xxl": "size-20",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export { buttonVariants }
export type { VariantProps as ButtonVariantProps }
